import { useNavigate } from "react-router-dom";
import { auth } from "./firebase"; //our firebase.js file
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { FcGoogle } from "react-icons/fc";
import { ReactComponent as Logo } from './assets/logo.svg';

import React, { useEffect } from 'react';
import {loggedAlert} from "./services/eventService";

const SignIn = () => {
  const navigate = useNavigate();

  useEffect(() => {
      const auth = getAuth();
      const user = auth.currentUser;
      if (user){
        navigate("/timekeeping", { replace: true });
      }
  }, [navigate]); // dependency array

  const handleGoogleLogin = async () => {
      try {
        const provider = new GoogleAuthProvider();
        provider.setCustomParameters({ prompt: "select_account" });
        const user = await signInWithPopup(auth, provider);

        if (user) {
          navigate("/timekeeping", { replace: true }); //Ensures React Router updates
        }else{
          console.log("unable to go to timekeeping endpoint")
        }

      } catch (error) {
        loggedAlert("Google login error:" + error.message, 153, 1);
        console.error("Google login error:", error.message);
      }
    };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50 text-gray-800">
        <header className="p-4">
            <div className="max-w-7xl mx-auto flex justify-center">
                <Logo className="h-20 w-auto" />
            </div>
        </header>
      <main>
        <div className="flex flex-col items-center justify-center h-screen">
          <h2 className="text-2xl font-bold mb-4">Sign In</h2>
          <div onClick={handleGoogleLogin}>
            <FcGoogle size={24} />
          </div>
        </div>
      </main>
      <footer>
        <div><p>Version: {process.env.REACT_APP_VERSION}</p></div>
      </footer>
    </div>
  );
};

export default SignIn;
